import { BackTestChartsWrapper } from 'components/common-form/sidePanel/backTest/BackTestChartsWrapper';
import type { ChartProps } from 'components/common-form/sidePanel/backTest/shared';
import { useBackTestOptions } from 'components/common-form/sidePanel/backTest/useBackTestOptions';
import type { Options, XAxisOptions, YAxisOptions } from 'highcharts/highstock';
import { dateFormat } from 'highcharts/highstock';

export function TimeSerie(props: ChartProps<number>) {
  const commonOptions = useBackTestOptions(props);
  const xAxisOptions = commonOptions.xAxis as XAxisOptions;
  const yAxisOptions = commonOptions.yAxis as YAxisOptions;

  const options: Options = {
    ...commonOptions,
    title: {
      text: '',
    },
    xAxis: {
      ...xAxisOptions,
      type: 'datetime',
      tickWidth: 0,
      scrollbar: { enabled: true, showFull: false },
      labels: {
        ...xAxisOptions?.labels,
        useHTML: true,
        formatter() {
          const timestamp = this.value as number;
          const month = dateFormat('%b', timestamp);
          const year = dateFormat('%Y', timestamp);
          return `<div class="text-center fw-bold">${month.toUpperCase()}<br/><span class="text-secondary">${year}</span></div>`;
        },
      },
      title: {
        ...xAxisOptions?.title,
        text: '',
      },
    },
    yAxis: {
      ...yAxisOptions,
      title: {
        ...yAxisOptions?.title,
        text: '',
      },
    },
  };

  return <BackTestChartsWrapper highchartsOptions={options} hasCopyToClipBoard={props.hasCopyToClipBoard} />;
}
